export enum OnboardingFieldKey {
  PHONE = "phone",
  ORGANIZATION = "organization",
  PERFIL = "perfil",
  NUMERO_FUNCIONARIOS = "numero_funcionarios",
  NUMERO_CLIENTES = "numero_clientes",
  SERVICOS = "servicos",
  SOFTWARE_GESTAO_TAREFAS = "software_gestao_tarefas",
  TIPOS_ARQUIVOS = "tipos_arquivos",
  FREQUENCIA_APROVACAOES = "frequencia_aprovacoes",
  SOFTWARE_APROVACAO_CONTEUDO = "software_aprovacao_conteudo",
  CARGO = "cargo",
}
